export default __webpack_public_path__ + "static/media/ff_id.4c97571e.png";